const richTextFieldHasContent = (content = {}) =>
  Object.values(content).some((element) =>
    element.some?.(
      (i) =>
        i?.data ||
        i?.value ||
        Object.values(i).some?.((it) =>
          it.some?.(
            ({ value, content: innerContent = [] }) =>
              value || innerContent?.some((ic) => richTextFieldHasContent(ic)),
          ),
        ),
    ),
  )

export default richTextFieldHasContent
